import { registerEnumType } from 'type-graphql'

export enum WebhookDeliveryStatusEnum {
  pending = 'pending',
  success = 'success',
  permanentlyFailed = 'permanently_failed',
  temporarilyFailed = 'temporarily_failed',
}

registerEnumType(WebhookDeliveryStatusEnum, {
  name: 'WebhookDeliveryStatusEnum',
  description: 'Delivery status for webhooks',
})
